/**
 * Filtre partagé des workflow templates visibles pour un utilisateur admin.
 *
 * Sprint V1 · Point 9 : les snapshots internes (`snap_*`), les templates
 * de test (`test_wf_*`) et les templates dossier historiques (`del_*`)
 * ne doivent JAMAIS apparaître dans la liste admin.
 *
 * À utiliser dans TOUS les endroits qui affichent des templates :
 *   - Page /parametres/workflows
 *   - Drawer "Nouveau dossier"
 *   - Toute vue future de sélection
 */
const HIDDEN_PREFIXES = ["snap_", "test_wf_", "del_"];

export function isVisibleTemplate(tpl) {
  if (!tpl) return false;
  const slug = tpl.slug || "";
  if (HIDDEN_PREFIXES.some((p) => slug.startsWith(p))) return false;
  return true;
}

export function filterVisibleTemplates(list) {
  return (Array.isArray(list) ? list : []).filter(isVisibleTemplate);
}

export function filterActiveVisibleTemplates(list) {
  return filterVisibleTemplates(list).filter(
    (t) => (t.status ? t.status === "active" : true)
  );
}
